import {
    RaikoAlert, raikoAlertTypes,
    RaikoBaseCardContainer, RaikoConfirmDialog,
    RaikoGridOneColumn,
    RaikoSectionContainer, showErrorMessage, showSuccessMessage
} from "@moeindal/base-raiko-panel-components";
import {useNavigate, useParams} from "react-router-dom";
import {useAuthState} from "../../../context/AuthContext";
import {LoanService} from "../../../serverService/loan/LoanService";
import {LoadingHelper} from "../../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../../context/LoadingContext";
import {useState} from "react";
import {detectServerErrorMessage} from "../../../util/detectServerErrorMessage";
import {RouteHelper} from "../../../route/RouteHelper";

export default function LoanDetailDeleteLoan() {

    const {id: loanId} = useParams()

    const {fundID} = useAuthState()

    const service = new LoanService()
    const loading = new LoadingHelper(useLoadingDispatcher())

    const [confirmDialog, setConfirmDialog] = useState(false);
    const openConfirmDialog = () => setConfirmDialog(true)
    const closeConfirmDialog = () => setConfirmDialog(false)

    const navigate = useNavigate()

    function handleDeleteLoan() {
        loading.show()
        service.deleteLoan(fundID, loanId)
            .then(response => {
                showSuccessMessage("وام با موفقیت حذف شد.")
                navigate(
                    RouteHelper.LoansList.globalUrl,
                    {replace: true}
                )
                closeConfirmDialog()
            }).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            loading.hide()
        })
    }


    return (
        <>
            <RaikoConfirmDialog
                cancelAction={closeConfirmDialog} openConfirmDialog={confirmDialog} doAction={handleDeleteLoan}
                pageTitle={"حذف وام"}
                warningTitle={"آیا از این مورد اطمینان دارید؟"}
                warningDescription={""}
                confirmButtonTitle={"حذف وام"}
            />
            <RaikoGridOneColumn>
                <RaikoBaseCardContainer>
                    <RaikoSectionContainer
                        title={"حذف وام"}
                        hasActionButton
                        actionButtonTitle={"حذف وام"}
                        actionButtonOnclick={openConfirmDialog}
                    >
                        <RaikoAlert
                            title={"لطفا قبل از ادامه به نکات زیر توجه فرمایید."}
                            type={raikoAlertTypes.warning}
                            description={[
                                "با اتمام حذف امکان بازیابی آن وجود نخواهد داشت.",
                                "اطلاعات وام و اقساط از سامانه حذف خواهد شد و تنها اطلاعات پرداخت اقساط باقی خواهد ماند."
                            ]}
                        />
                    </RaikoSectionContainer>
                </RaikoBaseCardContainer>
            </RaikoGridOneColumn>
        </>
    )
}
